import { render } from "./SearchBar.vue?vue&type=template&id=e06e1aa8&scoped=true"
import script from "./SearchBar.vue?vue&type=script&lang=js"
export * from "./SearchBar.vue?vue&type=script&lang=js"

import "./SearchBar.vue?vue&type=style&index=0&id=e06e1aa8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e06e1aa8"]])

export default __exports__